import { AbstractControl, ValidatorFn } from '@angular/forms';

export function stringExclusionValidator(...args: string[]): ValidatorFn {
	return (control: AbstractControl) => {
		const password: string = control.value?.toLowerCase();
		let passes = true;

		args.forEach(val => {
			if (!passes || !val) return;
			passes = val.length > 2 && !password?.includes(val.replace(/  +/g, ' ').trim().toLowerCase());
		});

		return !passes ? { stringExclusion: true } : null;
	};
}
